'use client';

import { Gift, Percent, Star, Sparkle } from '@phosphor-icons/react';

const STATS = [
  { icon: Gift, label: 'Бесплатные роллы', desc: 'К каждому заказу' },
  { icon: Percent, label: 'Промокоды', desc: 'Дополнительные скидки' },
  { icon: Star, label: 'Бонусы', desc: 'За заказы и отзывы' },
];

export function ActionsHero() {
  return (
    <section className="relative pt-28 pb-16 sm:pt-32 sm:pb-20 bg-gradient-to-b from-[var(--bg-secondary)] to-[var(--bg-primary)]">
      {/* Gradient blobs */}
      <div className="blur-blob absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-[var(--primary)]/10 blur-[100px]" />
      <div className="blur-blob absolute top-1/2 -left-32 w-[400px] h-[400px] rounded-full bg-[var(--violet-400)]/8 blur-[80px]" />
      <div className="blur-blob absolute bottom-0 right-1/4 w-[300px] h-[300px] rounded-full bg-[var(--primary)]/6 blur-[90px]" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="max-w-3xl space-y-7">
          {/* Badge */}
          <div className="animate-fade-up">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[var(--primary-subtle)] text-[var(--primary)] text-sm font-semibold">
              <Sparkle weight="fill" className="w-4 h-4" />
              Специальные предложения
            </span>
          </div>

          {/* Heading */}
          <h1
            className="text-4xl sm:text-5xl lg:text-6xl font-heading font-black leading-[1.05] tracking-tight text-[var(--text-primary)] animate-fade-up"
            style={{ animationDelay: '80ms' }}
          >
            Выгодные{' '}
            <span className="text-[var(--primary)]">акции</span>
            <br />
            каждый день
          </h1>

          {/* Subtitle */}
          <p
            className="text-lg sm:text-xl text-[var(--text-secondary)] max-w-xl leading-relaxed animate-fade-up"
            style={{ animationDelay: '160ms' }}
          >
            Бесплатные роллы, рулетка с подарками и бонусы за первый заказ.
            Воспользуйтесь нашими предложениями прямо сейчас.
          </p>

          {/* Stats row */}
          <div
            className="flex flex-wrap gap-6 animate-fade-up"
            style={{ animationDelay: '240ms' }}
          >
            {STATS.map((stat, i) => (
              <div key={i} className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-xl bg-[var(--primary-subtle)] flex items-center justify-center shrink-0">
                  <stat.icon weight="fill" className="w-5 h-5 text-[var(--primary)]" />
                </div>
                <div>
                  <p className="text-sm font-bold text-[var(--text-primary)]">{stat.label}</p>
                  <p className="text-xs text-[var(--text-tertiary)]">{stat.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
